import React from "react";
import { Link } from "react-router-dom";

import { missionId, getLoginLink } from "utils/urls";
import { missionNames } from "constants/missions";

import missionConfig from "missionConfig";

import FindOutMoreGol from "components/FindOutMore/FindOutMoreGol";
import FindOutMoreNectar from "components/FindOutMore/FindOutMoreNectar";
import FindOutMoreSmartshop from "components/FindOutMore/FindOutMoreSmartshop";
import PageFormat from "components/PageFormat";

const contentMapper = {
  [missionNames.GOL]: <FindOutMoreGol />,
  [missionNames.NECTAR]: <FindOutMoreNectar />,
  [missionNames.SMARTSHOP]: <FindOutMoreSmartshop />,
};

const { showBackToLoginButton } = missionConfig;

const FindOutMorePage = () => (
  <PageFormat>
    {contentMapper[missionId]}
    {showBackToLoginButton && (
      <Link
        to={getLoginLink()}
        className="back-to-login ln-c-button ln-c-button--outlined ln-u-margin-bottom*4 ln-u-margin-top*4"
      >
        Back to Log in
      </Link>
    )}
  </PageFormat>
);

export default FindOutMorePage;
